import { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { toast } from 'react-toastify';
import { FormRow } from '@gravity-ui/components';
import { Plus, TrashBin } from '@gravity-ui/icons';
import { Button, Icon, TextInput, Tooltip } from '@gravity-ui/uikit';

import { ADD_SUBSECTION, DELETE_SECTION, DELETE_SUBSECTION, SECTION, SUBSECTION } from 'features/admin-mode/constants';

import { DeleteModal } from '../delete-modal';

import styles from './styles.module.scss';
import { DeleteSheet } from '../delete-modal/delete-sheet';

interface Subsection {
	id?: number;
	sectionName: string;
	code: string;
	parentCode: string | null;
}

interface Section {
	id?: number;
	sectionName: string;
	code: string;
	subsections: Subsection[];
}

interface FormValues {
	sections: Section[];
}

export const SectionForm = ({
	sectionName,
	register,
	control,
	index,
	removeSection,
	deleteSection,
	refetch,
	id,
	isMobile,
}: any) => {
	const [open, setOpen] = useState(false);

	const { append, remove, fields } = useFieldArray<FormValues, `sections.${number}.subsections`, 'fieldId'>({
		control,
		name: `sections.${index}.subsections`,
		keyName: 'fieldId',
	});

	const removeSubsection = (subIndex: number) => {
		const subsectionToDelete = fields[subIndex];

		if (subsectionToDelete.id) {
			deleteSection(subsectionToDelete.id)
				.unwrap()
				.then(() => {
					remove(subIndex);
					refetch();
					toast.success('Подраздел успешно удалён');
				})
				.catch((error: any) => {
					console.error('Ошибка удаления подраздела:', error, fields);
					toast.error('Не удалось удалить подраздел');
				});
		} else {
			remove(subIndex);
		}
	};

	return (
		<div className={styles.block}>
			<div className={styles.block__delete}>
				<span>{index + 1}.</span>
				<Tooltip content={DELETE_SECTION} placement="top" openDelay={100} contentClassName={styles.tooltip}>
					<div tabIndex={0}>
						<Button onClick={() => setOpen(true)} view="flat" size="l">
							<TrashBin />
						</Button>
						{isMobile ? (
							<DeleteSheet open={open} setOpen={setOpen} id={id} removeSection={removeSection} />
						) : (
							<DeleteModal open={open} setOpen={setOpen} id={id} removeSection={removeSection} />
						)}
					</div>
				</Tooltip>
			</div>

			<FormRow label={SECTION} required className={styles.row}>
				<TextInput
					defaultValue={sectionName}
					{...register(`sections.${index}.sectionName`)}
					hasClear
					size="xl"
				/>
			</FormRow>
			{fields.map((field, subIndex) => (
				<FormRow key={field.fieldId} required label={SUBSECTION} className={styles.row}>
					<TextInput
						className={styles.row__subsection}
						size="xl"
						defaultValue={sectionName}
						{...register(`sections.${index}.subsections.${subIndex}.sectionName`)}
						hasClear
					/>

					<Tooltip
						content={DELETE_SUBSECTION}
						placement="top"
						openDelay={100}
						contentClassName={styles.tooltip}
					>
						<div tabIndex={0}>
							<Button
								view="outlined"
								size="l"
								className={styles.block__delete}
								onClick={() => removeSubsection(subIndex)}
							>
								<TrashBin />
							</Button>
						</div>
					</Tooltip>
				</FormRow>
			))}
			<div className={styles.block__btn_add_subsection}>
				<Button
					size="xl"
					view="outlined"
					onClick={() =>
						append({
							id: undefined,
							code: '',
							sectionName: '',
							parentCode: sectionName,
						})
					}
				>
					<Icon data={Plus} size={18} />
					{ADD_SUBSECTION}
				</Button>
			</div>
		</div>
	);
};
